import "./Experience.module.css";
import Header from "@/reusable_sections/Header";
import Concierge from "./sections/Concierge";
import Standards from "./sections/Standards";
import Glow from "./sections/Glow";
import Conciergeservicetiers from "./sections/Conciergeservicetiers";
import Footer from "@/reusable_sections/Footer";
export default function ExperiencePage() {
  return <div>
      <Header />
      <Concierge />
      <Standards />
      <Conciergeservicetiers />
      <Glow />
      <Footer />
    </div>;
}